import Content from "uxp-documentation/src/pages/uxp-api/reference-js/Modules/uxp/Entry Points/UxpPanelInfo";
import * as React from 'react';
export default {
  Content,
  React
};